import { render, staticRenderFns } from "./StaffCompanyInstructionPerModule.vue?vue&type=template&id=3e2f80df&scoped=true&"
import script from "./StaffCompanyInstructionPerModule.vue?vue&type=script&lang=js&"
export * from "./StaffCompanyInstructionPerModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f80df",
  null
  
)

export default component.exports